import { formatISOtoBEDateTime } from "react-lib/utils/dateUtils";
import formatComma from "react-lib/utils/formatComma";

import { ButtonV4, ModalV4 } from "../common/ui";

import type { DepositReceipt } from "../common/sequence/BillingWalletV4";
import { amountOf } from "./billingModelV4";
import type { DepositView } from "./ModalBillingDepositV4";

// Types
type ModalBillingDepositReceiptV4Props = {
  // data
  receipt: DepositReceipt;
  view: DepositView;
  hn?: string | null;
  busy?: boolean;
  // callback
  onPrint: () => void;
  onClose: () => void;
};

/** ใบรับเงินมัดจำ หลังรับฝากสำเร็จ */
const ModalBillingDepositReceiptV4 = (props: ModalBillingDepositReceiptV4Props) => (
  <ModalV4
    title="ใบรับเงินมัดจำ"
    width={560}
    className="hv4-bill-dep-modal"
    onClose={props.onClose}
  >
    <div className="hv4-bill-rcp">
      <div className="hv4-bill-rcp-row">
        <b>เลขที่ {props.receipt.code || "-"}</b>
        <span>{formatISOtoBEDateTime(props.receipt.created).dateTimeShort || ""}</span>
      </div>
      <div>
        ผู้รับบริการ: {props.receipt.patient_name || "-"} (HN {props.hn || "-"})
      </div>
      <div>
        รายการ: <b>{props.view.name}</b>{" "}
        <span className="hv4-bill-rcp-soft">({props.view.code})</span>
      </div>
      <div className="hv4-bill-rcp-row hv4-bill-rcp-amount">
        <span>จำนวนเงินมัดจำ</span>
        <span>{formatComma(amountOf(props.receipt.price) || props.view.amount)} ฿</span>
      </div>
      {props.view.rows.map((row, index) => (
        <div key={index} className="hv4-bill-rcp-row">
          <span>
            {row.label}
            {row.detail && <span className="hv4-bill-rcp-detail"> · {row.detail}</span>}
          </span>
          <span>{formatComma(row.value)}</span>
        </div>
      ))}
      {props.view.change > 0 && (
        <div className="hv4-bill-rcp-row">
          <span>เงินทอน</span>
          <span>{formatComma(props.view.change)}</span>
        </div>
      )}
      {props.view.note && <div className="hv4-bill-rcp-soft">หมายเหตุ: {props.view.note}</div>}
    </div>
    <div className="hv4-bill-rcp-foot">
      <ButtonV4 variant="ghost" onClick={props.onClose}>
        ปิด
      </ButtonV4>
      <ButtonV4 variant="primary" disabled={props.busy} onClick={props.onPrint}>
        พิมพ์ใบรับมัดจำ
      </ButtonV4>
    </div>
  </ModalV4>
);

ModalBillingDepositReceiptV4.displayName = "ModalBillingDepositReceiptV4";

export default ModalBillingDepositReceiptV4;
